"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoles = exports.hasInvitePermission = exports.isOwner = exports.isPending = exports.isNotMember = exports.isJoined = exports.isMember = exports.isAdmin = exports.hasSiteAdminRole = exports.hasAdminRole = exports.GROUP_OWNER = void 0;
var types_1 = require("../../types");
exports.GROUP_OWNER = 'GROUP_OWNER';
function hasAdminRole(roles) {
    return roles && roles.includes(types_1.ApiTypes.v1.RoleInGroup.GROUP_ADMIN);
}
exports.hasAdminRole = hasAdminRole;
function hasSiteAdminRole(roles) {
    return roles && roles.includes(types_1.ApiTypes.v1.RoleInGroup.SITE_ADMIN);
}
exports.hasSiteAdminRole = hasSiteAdminRole;
function isAdmin(memberRole) {
    try {
        var roles = memberRole.roles;
        return hasAdminRole(roles);
    }
    catch (e) { }
    return false;
}
exports.isAdmin = isAdmin;
function isMember(memberRole) {
    try {
        return memberRole.roles.includes(types_1.ApiTypes.v1.RoleInGroup.GROUP_MEMBER);
    }
    catch (e) { }
    return false;
}
exports.isMember = isMember;
function isJoined(groupOrMember) {
    var relationship = groupOrMember.relationship;
    return relationship === types_1.ApiTypes.v1.RelationshipWithGroup.JOINED;
}
exports.isJoined = isJoined;
function isNotMember(groupOrMember) {
    var relationship = groupOrMember.relationship;
    return relationship === types_1.ApiTypes.v1.RelationshipWithGroup.NONE;
}
exports.isNotMember = isNotMember;
function isPending(groupOrMember) {
    var relationship = groupOrMember.relationship;
    return relationship === types_1.ApiTypes.v1.RelationshipWithGroup.PENDING_APPROVAL;
}
exports.isPending = isPending;
function isOwner(group, member) {
    try {
        var siteMemberId = group.createdBy.siteMemberId;
        return siteMemberId === member.siteMemberId;
    }
    catch (e) { }
    return false;
}
exports.isOwner = isOwner;
function hasInvitePermission(group) {
    var permittedToInviteMembers = group.settings.permittedToInviteMembers;
    return (isJoined(group) &&
        permittedToInviteMembers === types_1.ApiTypes.v1.RoleInGroup.GROUP_MEMBER);
}
exports.hasInvitePermission = hasInvitePermission;
function getRoles(group, member) {
    return isOwner(group, member) ? [exports.GROUP_OWNER] : member.roles || [];
}
exports.getRoles = getRoles;
//# sourceMappingURL=MemberRole.js.map